import * as AppConstants from 'app/AppConstants';

const initialState = () => ({
  trends: {},
  viewCounts: {},
});

export default (state = initialState(), action) => {
  switch (action.type) {
    case AppConstants.HOME__TREND_LOAD_FINISHED: {
      return {
        ...state,
        trends: {
          ...state.trends,
          [action.payload.id]: action.payload.trend,
        },
      };
    }
    case AppConstants.HOME__VIEW_COUNTS_LOADED: {
      return {
        ...state,
        viewCounts: {
          ...state.viewCounts,
          ...action.payload.viewCounts,
        },
      };
    }

    default:
      return state;
  }
};
